import { render, staticRenderFns } from "./ModalCategories.vue?vue&type=template&id=43e954c6&scoped=true&"
import script from "./ModalCategories.vue?vue&type=script&lang=js&"
export * from "./ModalCategories.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategories.vue?vue&type=style&index=0&id=43e954c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e954c6",
  null
  
)

export default component.exports